export const isNotificationPopoverVisible = (pathname: string) => {
	if (pathname.includes('feedback')) {
		return true;
	} 
	return false;
};